import React from 'react';
import MainHeader from './MainHeader';
import Footer from './Footer';
import CliniciansProspect from './CliniciansProspect';
import MobileFooter from './MobileFooter';
import MetaTags from 'react-meta-tags';
import StickyContactMenu from './StickyContactMenu';



class CliniciansGeneticCounselling extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0)
  }

  toMedical() {
        window.location.href="/clinicians_medical";
    }

    
    toGeneticHelp() {

       window.location.href="/clinicians_genetic-help";
      }
  render() {
    return (
      

      <div>
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
      <link rel="stylesheet" href="https://www.w3schools.com/w3css/4/w3.css" />
      <link href="https://fonts.googleapis.com/css?family=Roboto:100,100i,300,300i,400,400i,500,500i,700,700i,900,900i" rel="stylesheet" />
      <link href="//maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet" />
      <link rel="stylesheet" href="./fonts/fontawesome-free-5.8.2-web/css/all.css" type="text/css" />
      <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css" integrity="sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T" crossOrigin="anonymous" />
      <title>truGeny</title>
      <link rel="icon" href="./img/Logo.png" type="image/gif" sizes="16x16" />
      <link rel="stylesheet" href="./css/header_footer.css" />
      <link rel="stylesheet" href="./css/stylesheet_custom.css" />
      <link rel="stylesheet" href="stylesheet_custom.css" />
      <link rel="stylesheet" href="./css/fonts.css" />
      <link rel="stylesheet" href="./css/sticky.css" />
      <MetaTags>
        <title>Genetic Counseling for your Patients | Tele-genetic Counseling</title>
		<meta name="description" content="Thanks to truGeny, you can now integrate genetic counselling for genetic risk assessment into your practice."/>
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <meta property="og:title" content="Genetic Counseling for your Patients | Tele-genetic Counseling"/>
        <meta property="og:site_name" content="truGeny"/>
        <meta property="og:url" content="https://trugeny.com/"/>
        <meta property="og:description" content="Thanks to truGeny, you can now integrate genetic counselling for genetic risk assessment into your practice."/>
        <meta property="og:type" content="website"/>
        <meta property="og:image" content=""/>
</MetaTags>
     
      <style dangerouslySetInnerHTML={{__html: "\n/* @media only screen and (min-width: 1200px)\n{\n/* .custom-pad-mar {\n  padding-left:25rem;\n  padding-right:25rem;\n\n} */\n.genetics-banner-sec-wrap .genetics-banner-sec{\n  background: url(./img/clinicians/genetic-counseling/bg.png) no-repeat center;-webkit-background-size: cover;\n  background-position:center;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n.gc-help-main-sec{\n  background: url(./img/clinicians/genetic-counseling/bg-2.png) no-repeat center;-webkit-background-size: cover;\n  -moz-background-size: cover;\n  -o-background-size: cover;\n  background-size: cover;\n  background-position: top;\n}\n.gc-help-card-main-wrap .card-deck .card-deck-wrap .card{\n  border:none;\n  margin:0;\n  height:400px;\n    margin-top:3rem;\n}\n\n.pgc-help-main-sec{\n  /* background: url(./img/geneticspage/genetics-session-background.png) no-repeat center;-webkit-background-size: cover; */\n  -moz-background-size: cover;\n  -o-background-size: cover;\n  background-size: cover;\n  background-position: top;\n}\n\n.pgc-help-main-sec .pgc-help-main-wrap{\n  padding-top:130px;\n  padding-bottom:10px;\n  margin:0 auto;\n}\n\n.pgc-help-main-sec .pgc-help-main-wrap h2{\n  font-family: 'Roboto', sans-serif;\n  font-size:2.5rem;\n  font-weight:900;\n  margin:0 auto;\n}\n\n.pgc-help-card-main-wrap .pcard-deck .pcard-deck-wrap{\n  padding:0px 10px;\n  margin:0;\n}\n\n/*.gc-help-card-main-wrap .card-deck .card-deck-wrap:first-child{\n  padding-left:0px!important;\n\n}\n\n.gc-help-card-main-wrap .card-deck .card-deck-wrap:last-child{\n  padding-right:0px!important;\n\n}*/\n\n.pgc-help-card-main-wrap .card-deck .pcard-deck-wrap .card{\n  border:none;\n  margin:0;\n  height:440px;\n  margin-top:4rem;\n}\n\n.pgc-help-main-wrap .card-body .card-block .card-img{\n  height:160px;\n  width:160px;\n}\n\n.pgc-help-main-wrap .card-body .card-text{\n  font-size:1.125rem;\n  font-weight:900;\n}\n\n\n.pgc-help-button-wrap .gc-help-button{\n  padding: 15px 40px;\n  font-weight:bold;\n  font-size:0.875rem;\n  text-transform: uppercase;\n}\n/* @media (min-width: 992px) {\n\n}\n@media (min-width: 768px) {\n\n }\n @media (min-width: 576px) {\n\n  }\n  @media (min-width: 1200px) {\n     } */\n" }} />
      <link rel="stylesheet" href="./clinicians_style-mobile2.css"/>
        <link rel="stylesheet" href="./clinicians_style-mobile.css"/>
        <link rel="stylesheet" href="./clinicians_newsticky.css"/>
      <MainHeader category="genetic-counselling"></MainHeader>
      {/* eo-container */}
      <div style={{marginTop:'10rem'}} className="margin"></div>
      <section className="genetic-Counseling-main-sec genetics-banner-sec-wrap">
        <div className=" genetics-banner-sec ">
          <div className="container pt-4 mt-2">
            <h1>Seamless</h1>
            <p className="text-justify mt-3 mb-4" id="secc1">Integration of Genetic Counselling for genetic risk assessment into your Practice</p>
          </div>{/* eo-container*/}
          <div className="d-flex justify-content-center">
            <a style={{scrollBehavior: '[ auto | smooth ]'}} href="#secc1">  <img className="img-fluid d-none d-md-block d-lg-block btn-hover-white1" src="./img/111.png" /></a>
          </div>
        </div>{/* eo-heart-banner-sec */}
      </section>{/* eo-heart-banner-sec-wrap */}
      <StickyContactMenu></StickyContactMenu>
      {/* ------------------------------------------------------heart-banner-sec over------------------------------------------------------------------ */}
      <section className="genetics-informed-sec-main heart-disease-sec-main heart-disease-sec-main">
        <div className="heart-disease-sec-main-wrap container">
          <div className="genetics-intro-text text-center">
            <h2 className=" text-center genetics-h2 ">We help you, help your patients</h2>
          </div>{/* eo-intro-text-wrap*/}
          <div className=" heart-disease-sec row container">
            <div className=" hd-img col-xs-12 col-sm-12 col-md-6 mb-sm-5 mb-xs-5 d-block text-center  ">
              <img className="img-fluid mx-auto" src="./img/clinicians/genetic-counseling/Illustration1.png" />
            </div>{/* eo-hd-img */}
            <div className=" col-xs-12 col-sm-12 col-md-6 mt-md-0 mt-sm-5 mt-xs-5 hd-text align-self-center">
              <h3>Personalised</h3>
              <p className="heartdisease-content">Our telegenetics platform helps you to deliver a highly personalised service with deep medical expertise for genetic counselling to all your patients.</p>
              <p className="heartdisease-content">Your patients can now receive genetic counselling from the comfort of their home at a convenient time.</p>
            </div>{/* eo-hd-text */}
          </div>{/* eo-row */}
          <div className="families-sec heart-disease-sec row container">
            <div className=" hd-img col-xs-12 col-sm-12 col-md-6 mb-sm-5 mb-xs-5 text-center order-md-2">
              <img className="img-fluid mx-auto" src="./img/clinicians/genetic-counseling/Illustration2.png" />
            </div>{/* eo-hd-img */}
            <div className=" col-xs-12 col-sm-12 col-md-6 mt-md-0 mt-sm-5 mt-xs-5 hd-text align-self-center order-md-1">
              <h3>Medical Specialities</h3>
              <p className="heartdisease-content">Rely on our board certified genetic counsellors with deep subject matter expertise across medical specialties.</p>
             <br/>
              <button type="button" className="btn btn-outline-primary mt-2 btn-hover-white rounded-pill mt-4" onClick={this.toMedical} >LEARN MORE&nbsp;&nbsp;<i className="fas fa-long-arrow-alt-right" />
              </button></div>{/* eo-hd-text */}
          </div>{/* eo-row */}
        </div>{/* eo-heart-disease-sec-main-wrap*/}
        <div className="container py-lg-5 py-sm-0 mt-3">
          <h3 className="roboto-black-40px text-center mt-4 p-2">Personalized medicine is here today and is a rapidly growing field.</h3>
          <p className="roboto-reg-18px text-center mt-4 p-2">There has been explosive growth in the number of genetic tests in the market. Knowing which tests to order, how to interpret results, and how to change a patients’ healthcare management based on results becomes a very complex task.</p>
          <p className="roboto-reg-18px text-center mt-4 p-2">Once we understand your patient’s genetic counselling needs, we allocate a genetic counsellor with expertise in their medical area. After the counselling session with the patient, a summary of our discussion and recommendations will be provided.</p>
        </div>
      </section>{/* eo-heart-disease-sec-main */}
      {/* Start of Genetic Counsell Help cards  */}
      <div className="paddingClini">
      </div>
      <div className="gc-help-main-sec">
        <div className="container gc-help-main-wrap">
          <h2 className="text-center">Your patients will recieve</h2>
          <div className="container gc-help-card-main-wrap mx-auto mt-5  mb-5">
            <div className="card-deck">
              <div className="card-deck-wrap col-sm-12 col-md-6 col-lg-4">
                <div className="card rounded shadow-lg  mb-4 r4  ">
                  <div className="card-body text-center ">
                    <div className="card-block mt-2 p-2 circle">
                      <img className="card-img img-fluid text-center p-2 " src="./img/clinicians/genetic-counseling/card1.png" alt="Card image cap" />
                    </div>
                    <p className="card-text">Understanding of their Genetic Risks</p>
                    <p>Your patient will receive a 30 to 60 minute phone / video consultation where they will be made to understand about genetics and their risks for certain inherited conditions.</p>
                  </div>{/* eo-card-body */}
                </div>{/* eo-card */}
              </div>{/* eo-card-deck-wrap */}
              <div className="card-deck-wrap col-sm-12 col-md-6 col-lg-4">
                <div className="card rounded shadow-lg mb-4 r4 ">
                  <div className="card-body text-center">
                    <div className="card-block p-2 circle">
                      <img className="card-img text-center p-2" src="./img/clinicians/genetic-counseling/card2.png" alt="Card image cap" />
                    </div>
                    <p className="card-text">Genetic Tests</p>
                    <p>Patients will learn about various testing options and their implications.</p>
                  </div>
                </div>
              </div>{/* eo-card-deck-wrap */}
              <div className="card-deck-wrap col-sm-12 col-md-6 col-lg-4">
                <div className="card rounded shadow-lg  mb-4 r4 ">
                  <div className="card-body text-center">
                    <div className="card-block mt-2 p-2 circle ">
                      <img className="card-img text-center  p-lg-5 p-sm-0" src="./img/clinicians/genetic-counseling/card3.png" alt="Card image cap" />
                    </div>
                    <p className="card-text">Understanding of their Genetic Test Reports</p>
                    <p>A 30-60 minute consultation to help your patient interpret and understand the results of a genetic test. The counsellor will not only answer questions but also guide the patient on the next steps to consider.</p>
                  </div>
                </div>
              </div>{/* eo-card-deck-wrap */}
            </div>{/* eo-card-deck */}
          </div>{/*eo-container */}
          <div className="gc-help-button-wrap text-center">
            {/* <a class="gc-help-button btn btn-outline-primary btn-hover-white rounded-pill text-center" href="#" role="button">Schedule Your Appointment</a> */}
          </div>{/* gc-help-button-wrap */}
        </div>{/* gc-help-main-wrap */}
      </div>{/* gc-help-main-sec */}
      {/* end of Genetic Counsell Help cards  */}
      <div className="pgc-help-main-sec">
        <div className="container pgc-help-main-wrap">
          <h2 className="text-center">Our service focuses on three clinical areas</h2>
          <div className="container pgc-help-card-main-wrap mx-auto mt-lg-5 mt-sm-2  mb-5">
            <div className="card-deck">
              <div className="pcard-deck-wrap col-sm-12 col-md-6 col-lg-4">
                <div className="card rounded shadow-lg  mb-4 r4  ">
                  <div className="card-body text-center ">
                    <div className="card-block mt-2 p-2 circle">
                      <img className="card-img img-fluid text-center p-2 " src="./img/clinicians/genetic-counseling/card2-1.png" alt="Card image cap" />
                    </div>
                    <p className="card-text">Hereditary Cancers</p>
                    <p>Family history-based risk assessment and counselling, guidance on choosing appropriate test and interpretation of test results.
                    </p>
                  </div>{/* eo-card-body */}
                </div>{/* eo-card */}
              </div>{/* eo-card-deck-wrap */}
              <div className="pcard-deck-wrap col-sm-12 col-md-6 col-lg-4">
                <div className="card rounded shadow-lg  mb-4 r4  ">
                  <div className="card-body text-center ">
                    <div className="card-block mt-2 p-2 circle">
                      <img className="card-img img-fluid text-center p-2 " src="./img/clinicians/genetic-counseling/card2-2.png" alt="Card image cap" />
                    </div>
                    <p className="card-text">Prenatal Counselling</p>
                    <p>Helping couples understand their risks more clearly, and discuss options for prenatal screening, testing. </p>
                  </div>{/* eo-card-body */}
                </div>{/* eo-card */}
              </div>{/* eo-card-deck-wrap */}
              <div className="pcard-deck-wrap col-sm-12 col-md-6 col-lg-4">
                <div className="card rounded shadow-lg mb-4 r4 ">
                  <div className="card-body text-center">
                    <div className="card-block p-2 circle">
                      <img className="card-img text-center p-2" src="./img/clinicians/genetic-counseling/card2-4.png" alt="Card image cap" />
                    </div>
                    <p className="card-text">Heart Disease Risk</p>
                    <p>Family history-based risk assessment, counselling regarding genetic testing options, and interpretation of test results.</p>
                  </div>
                </div>
              </div>{/* eo-card-deck-wrap */}
            </div>{/* eo-card-deck */}
          </div>{/*eo-container */}
          <div className="gc-help-button-wrap text-center">
            {/* <a class="gc-help-button btn btn-outline-primary btn-hover-white rounded-pill text-center" href="#" role="button">Schedule Your Appointment</a> */}
          </div>{/* gc-help-button-wrap */}
        </div>{/* gc-help-main-wrap */}
      </div>
      {/* Genes can influence section starts here */}
      <br/>
      <section className="genetics-informed-sec-main heart-disease-sec-main heart-disease-sec-main">
        <div className="heart-disease-sec-main-wrap container sec-6">
          <div className="genetics-intro-text text-center">
            <h2 className=" text-center genetics-h2 " style={{fontSize: '40px'}}>Empower</h2>
            <p className="roboto-reg-36px">We empower your patients with highly personalised information about their risks and the option to manage their risks.</p>
            <h2 className=" text-center genetics-h2 " style={{fontSize: '40px'}}>As a Doctor</h2>
            <p className="roboto-reg-36px px-3">you can now avoid the need to refer outside of your practice, while still ensuring your patient has access to the highest quality of genetics expertise.</p>
          </div>{/* eo-intro-text-wrap*/}
          <div className=" heart-disease-sec row container sec6">
            <div className=" hd-img col-xs-12 col-sm-12 col-md-6 mb-sm-5 mb-xs-5 d-block text-center align-self-center ">
              <img className="img-fluid mx-auto p-5" src="./img/clinicians/genetic-counseling/Illustration3.png" />
            </div>{/* eo-hd-img */}
            <div className=" col-xs-12 col-sm-12 col-md-6 mt-md-0 mt-sm-5 mt-xs-5 hd-text ">
              <h3 className="pl-0">Why should you consider using truGeny’s telegenetic platform?</h3>
              {/* <p class="heartdisease-content">You will receive a 30 - to 60- minute phone or video consultation, with our genetic counsellors. They will discuss your genetic risks, and various testing options as appropriate and help you understand the significance of testing.</p> */}
              {/* <p class="heartdisease-content font-weight-bold pb-4">It’s important to KNOW.</br>Learning about your inherited heart condition risks help you take actions.</p> */}
              <ul className="pl-1">
                <li>With Genetic Counselling, truGeny enables you to provide comprehensive care to all your patients.</li>
                <li>Offer easy access to Genetic Counselling to all your patients, regardless of how close or far they live from your office.</li>
                <li>When you partner with truGeny you will be adding an entire team of master’s-level genetics specialists to your practice.</li>
                <li>Our genetic counselling experts covers subspecialties including prenatal &amp; fertility, oncology, and cardiac.</li>
                <li>Get convenient access to rare specialists regardless of your location.</li>
                <li>Ensure the right test is done and offer your patient multidisciplinary care.</li>
              </ul>
            </div>
          </div>{/* eo-hd-text */}
        </div>{/* eo-row */}
        {/* eo-heart-disease-sec-main-wrap*/}
      </section>{/* eo-heart-disease-sec-main */}
      {/* ******************Our Process-sec************ */}
      {/* ******************End of Our Process-sec************ */}
      {/* /************genetic Counseling Session starts here*************** / */}
      {/* end of genetic risks */}
      {/* end of Genetic Session section */}
      {/* end of Genetic Cause section */}
      <section className="genetic-cause-sec-main d-none">
        <div className="genetic-cause-sec-wrap">
          <div className="genetic-cause-header-wrap">
            <h2 className="genetic-cause-header genetics-h2 pt-0 text-center">
              Most diseases have a genetic cause.
            </h2>
            <p className="genetic-cause-subtitle genetics-h2-p text-center">Our genetic counsellors can help evaluate if you’re at risk, and if genetic testing may be right for you.</p>
          </div>{/* eo gr-header */}
          <div className="questions-btn text-center mx-auto">
            <p >Find answers to common questions.</p>
            <a className="btn btn-outline-primary btn-hover-white rounded-pill text-center " href="#" role="button">Frequently Asked Questions</a>
          </div>
        </div>{/* genetic-cause-sec-wrap */}
      </section>{/* end of genetic-cause */}
      {/* end of genetic-cause */}
      {/* ******************End of Genetic Session section************ */}
      {/* ******************are you ready section************ */}
      <section className="ayr-sec-main heart-disease-sec-main d-none">
        <div className="ayr-sec-main-wrap heart-disease-sec-main-wrap container">
          <div className="intro-text-wrap text-center">
            <h2 className="text-center ">Are you Ready?</h2>
          </div>{/* eo-intro-text-wrap*/}
          <div className="families-sec heart-disease-sec row container">
            <div className=" hd-img col-xs-12 col-sm-12 col-md-6 mb-md-0 mb-sm-5 mb-xs-5 text-center align-self-center ">
              <img className="img-fluid mx-auto" src="./img/cancerpage/Illustrationg.png" />
            </div>{/* eo-hd-img */}
            <div className=" col-xs-12 col-sm-12 col-md-6 mt-md-0 mt-sm-5 mt-xs-5 hd-text align-self-center ">
              <h3>Start your journey to better health</h3>
              <p className="heartdisease-content">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo</p>
              <button type="button" className="btn btn-outline-primary btn-hover-white rounded-pill" data-toggle="modal" data-target="#exampleModalCenter">Am I Eligible<i className="fas fa-long-arrow-alt-right" />
              </button>
            </div>{/* eo-hd-text */}
          </div>{/* eo-row */}
        </div>{/* eo-heart-disease-sec-main-wrap*/}
      </section>{/* eo-heart-disease-sec-main */}
      {/* ******************end of are you ready section************ */}
      {/* **********Schedule your Genetic Counseling Session Starts Here************** */}
      {/* **********Schedule your Genetic Counseling Session Ends Here************** */}
     <CliniciansProspect></CliniciansProspect>
      {/* Footer Links */}
      <Footer></Footer>
      <MobileFooter></MobileFooter>
      {/* -------------------------------------start q and a------------------------------ */}
      <div className="modal fade bd-example-modal-lg d-none" id="exampleModalCenter" tabIndex={-1} role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div className="modal-content" style={{borderRadius: '40px'}}>
            <div className="modal-header bg-blue clearfix border-0" style={{borderTopRightRadius: '40px', borderTopLeftRadius: '40px'}}>
              <h5 className="modal-title" id="exampleModalLongTitle" style={{paddingTop: '5px', paddingBottom: '25px', color: '#2c333c', fontSize: '30px', fontWeight: 700}}>
                Start your journey in 3 easy steps</h5>
              <button type="button" className="text-center close" data-dismiss="modal" aria-label="Close" style={{paddingTop: '25px', paddingBottom: '25px'}}>
                <img className="img-fluid" src=".\img\registration\X.png" />
              </button>
              {/* <p class="float-left">Question 1 of 3</p> */}
            </div>
            <div className="bg-blue border-bottom-1">
              <p className="pl-3">Question 1 of 3</p>
            </div>
            <div className="modal-body pb-5 pt-0 m-0">
              <div className="container ">
                <br />
                <div className="tab-content">
                  <div id="home" className="container tab-pane active"><br />
                    <h3>How do you indentify your gender?</h3>          <hr />
                    <div className="d-flex d-flex-inline">
                      <img className="mr-3" src="./img/q&a/female.png" alt="" />
                      <img className="mr-3" src="./img/q&a/female.png" alt="" />
                    </div>
                    <div className="float-right pt-2 mt-2">
                      <button type="button" className="btn btn-outline-primary text-center custom-button btn btn-outline-primary btn-hover-white my-2 my-sm-0" data-toggle="pill" href="#menu1">Next</button>
                    </div>
                  </div>
                  <div id="menu1" className=" m-0 p-0 container tab-pane fade"><br />
                    <h3>Does anyone in your family have 2 diabetes?</h3><hr />
                    <h4>Certain ethnic groups have higher risk for diabetes,<br />
                      even at lower body weights.</h4>
                    <div className="col-xs-12 mt-2 ">
                      <div className="input-group-prepend " style={{border: 'solid 1px #ebebeb', maxWidth: '312px'}}>
                        <input type="text" placeholder="Select your ethnicity" className="form-control roboto-reg-16px" style={{border: 'none', height: '60px'}} aria-label="Text input with dropdown button" />
                        <button className="m-0 p-0 btn btn-outline-secondary roboto-bold-14px " href="#" style={{border: 'none', backgroundColor: 'white'}} type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><img className="m-0 p-0" src="img/q&a/carot.png" /></button>
                      </div>
                    </div>
                    <div className="float-right pt-2 mt-2">
                      <button type="button" className="btn btn-outline-primary text-center custom-button btn btn-outline-primary btn-hover-white my-2 my-sm-0" data-toggle="pill" href="#menu2">Next</button>
                    </div>
                  </div>
                  <div id="menu2" className=" m-0 p-0 container tab-pane fade"><br />
                    <h3>Does anyone in your family have 2 diabetes?</h3>
                    <hr />
                    <div className="radio">
                      <label><input type="radio" name="optradio" defaultChecked />  Parents</label>
                    </div>
                    <div className="radio">
                      <label><input type="radio" name="optradio" />  Siblings</label>
                    </div>
                    <div className="float-right pt-2 mt-2">
                      <button type="button" className="btn btn-outline-primary text-center custom-button btn btn-outline-primary btn-hover-white my-2 my-sm-0" data-toggle="pill"  href="#">Submit</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* sticky form---------------- */}
            {/* <div class="modal-footer">
                <button type="button" class="btn btn-secondary"  data-toggle="pill" href="#menu2">Close</button>
                <button type="button" class="btn btn-primary"  data-toggle="pill" href="#menu1">Next</button>
              </div> */}
          </div>
        </div>
      </div>
      {/* sticky form---------------- */}
    
      {/* --------eo sticky form----------------- */}
      {/* ----------------------------------------------------eo Q and A--------------------------------- */}
      {/* Optional JavaScript */}
      {/* jQuery first, then Popper.js, then Bootstrap JS */}
    </div>
    );
  }
}
export default CliniciansGeneticCounselling;
